import { validateContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { BLOCK_OPENAPI } from '../types';
import { replaceEditableApiBlocks } from './replaceEditableApiSchema';

const validateOpenApiRef = validateContentReference(['file', 'url', 'openapi']);
/*
 * Schema to validate OpenAPI blocks.
 */
export const schema = Schema.create({
    validations: [replaceEditableApiBlocks],
    blocks: {
        [BLOCK_OPENAPI]: {
            parent: { objects: ['document'] },
            isVoid: true,
            data: {
                path: (data: any) => typeof data === 'string',
                method: (data: any) => typeof data === 'string',
                ref: (data: any) => validateOpenApiRef(data),

                // whether block is expanded by default
                expanded: (data: any) => data === undefined || typeof data === 'boolean',

                fullWidth: (fullWidth) =>
                    typeof fullWidth === 'undefined' || typeof fullWidth === 'boolean',
            },
        },
    },
});
